'use client'
import React from 'react'
import { QueryClientProvider, HydrationBoundary, DehydratedState } from '@tanstack/react-query'
import { getQueryClient } from './queryClient'

export { getQueryClient } from './queryClient'

export function QueryProvider({ children, dehydratedState }: { children: React.ReactNode, dehydratedState?: DehydratedState }) {
  const queryClient = getQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <HydrationBoundary state={dehydratedState}>
        {children}
      </HydrationBoundary>
    </QueryClientProvider>
  )
}
